/* src/app/ai-sourcing/evaluation-criteria/evaluation-criteria.component.scss */
.gradient-text {
  background:
    linear-gradient(
      93.79deg,
      #9AE658 -6.34%,
      #37CAB5 116.46%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-style: italic;
}
.pink-gradient-header {
  background-image:
    linear-gradient(
      to right,
      #ffd5e3,
      #FCEDF2);
  color: #575757;
}
.pink-gradient-header .text-ai-screening {
  background-image:
    linear-gradient(
      to bottom,
      #9f38f0 0%,
      #e54f7a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ai-criteria-card {
  background-color: #FAFAFA;
  border-radius: 4px;
  padding: 12px 10px;
  margin-bottom: 15px;
}
.ai-criteria-card select.select-ai {
  border: 1px solid #cccccc;
  border-radius: 4px;
  color: #575757;
  font-weight: normal;
  width: 150px;
}
.ai-criteria-card input.wc-form-control {
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 6px 12px;
}
.ai-criteria-card .delete-option {
  border: 1px solid #cccccc;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin-left: 15px;
  cursor: pointer;
}
.ai-criteria-card .delete-option i {
  color: #2e93a1;
}
.criteria-drag-container {
  display: flex;
  align-items: center;
  width: 100%;
}
.criteria-drag-container .ai-criteria-card {
  width: 100%;
}
.ai-chip-container {
  margin-bottom: 15px;
  position: relative;
}
.ai-chip-container .ai-screening-chips {
  cursor: pointer;
  border: 1px solid transparent;
  background:
    linear-gradient(
      267.38deg,
      rgba(200, 69, 171, 0.04) 15.14%,
      rgba(226, 78, 127, 0.04) 52.19%);
  border-radius: 8px;
  color: #484B59;
  padding: 10px;
  margin-right: 0px;
  margin-bottom: 10px;
  align-items: center;
  position: relative;
  height: 38px;
}
.ai-chip-container .ai-screening-chips .gedient-criteria {
  position: absolute;
  background:
    linear-gradient(
      180deg,
      #9F38F0 15.14%,
      #E54F7A 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent !important;
  left: 10px;
  top: 9px;
}
.ai-chip-container .ai-screening-chips:hover {
  border: 1px solid #E54F7A;
}
.btn-get-talent-insight {
  padding: 12px 24px;
  border-radius: 4px;
  background-image:
    linear-gradient(
      253deg,
      #c845ab,
      #e24e7f);
  color: #fff;
  outline: none;
  border: 0;
  font-size: 16px;
  font-weight: 600;
}
.step-ai-screening {
  background-image:
    linear-gradient(
      to bottom,
      #9f38f0 0%,
      #e54f7a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.cursor-move {
  cursor: move;
}
.blue-label {
  background:
    linear-gradient(
      90deg,
      rgba(108, 189, 255, 0.2) 53.84%,
      rgba(255, 255, 255, 0.2) 105.62%);
  padding: 8px 16px;
  display: flex;
  margin-bottom: 8px;
}
.blue-label p.f-10 {
  font-size: 10px;
  color: #484b59;
}
.blue-label p.f-11 {
  font-size: 11px;
  color: #000000;
  font-style: italic;
}
.criteria-btn {
  background-color: #ffffff !important;
  color: #2e93a1 !important;
}
.disable-tab {
  opacity: 0.6;
}
.img-config-review {
  width: 170px;
  height: 130px;
}
.skeleton-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.skeleton-row {
  grid-template-columns: repeat(7, 1fr);
  gap: 12px;
}
.skeleton-row.header .skeleton-box {
  height: 18px;
  margin-top: 8px;
}
.skeleton-box {
  height: 14px;
  border-radius: 4px;
  background:
    linear-gradient(
      90deg,
      #e0e0e0 25%,
      #f5f5f5 50%,
      #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/*# sourceMappingURL=evaluation-criteria.component-QQAVFV2E.css.map */
